import { render } from "./AppLogComponent.vue?vue&type=template&id=28c86919&scoped=true"
import script from "./AppLogComponent.vue?vue&type=script&lang=js"
export * from "./AppLogComponent.vue?vue&type=script&lang=js"

import "./AppLogComponent.vue?vue&type=style&index=0&id=28c86919&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-28c86919"]])

export default __exports__